/**
 * SIP Slice - Manages SIP connection state and configuration
 */

import { StateCreator } from 'zustand';
import { SipSlice } from './index.types';

export * from './index.types';

export const createSipSlice: StateCreator<SipSlice> = (set) => ({
  // State
  status: 'disconnected',
  config: null,
  error: null,
  registrationAttempts: 0,
  lastRegistrationTime: null,
  isRecovering: false,
  isConnectionLossFeedbackActive: false,
  hasPoorTooltipShown: false,

  // Actions
  setStatus: (status) => set({ status }),
  setConfig: (config) => set({ config }),
  setError: (error) => set({ error }),
  setRecovering: (isRecovering) => set({ isRecovering }),
  incrementRegistrationAttempts: () =>
    set((state) => ({ registrationAttempts: state.registrationAttempts + 1 })),
  resetRegistrationAttempts: () => set({ registrationAttempts: 0 }),
  setLastRegistrationTime: (time) => set({ lastRegistrationTime: time }),
  setConnectionLossFeedbackActive: (active) =>
    set({ isConnectionLossFeedbackActive: active }),
  setHasPoorTooltipShown: (shown) =>
    set({ hasPoorTooltipShown: shown }),
});
